$(document).ready(function () {
  // General Message
  //--------------------------------------
  $('.generalmessage').prependTo('header');

  // Search Bar Script
  //--------------------------------------
  $('.searchBoxInput input').attr('placeholder', 'Search');
  $('.searchBoxInput input').val('');
  $('#mobileSearchInput').attr('placeholder', '');
  $('#mobileSearchInput').val('');


  // Footer signup
  $('.footer .emailSignup .emailInputSubmit a').text('Get News & Deals')
  $('.footer .emailSignup input').attr('placeholder', 'Enter Email...');
  $('.footer .emailSignup input').val('');

  // Effects for focus on signup
  $('.footer .emailSignup input').focus(function () {
    $('.emailSignup ').addClass('styleFocus');
    $('.emailInputField ').addClass('focusInput');
  });

  $('.footer .emailSignup input').blur(function () {
    $('.emailSignup ').removeClass('styleFocus');
    $('.emailInputField ').removeClass('focusInput');
  });



  // Theme animations
  $(window).load(function () {
    
    $('#countdown-container .inner-content').addClass('animation-in');

    setTimeout(() => {
      $('.footer-sticky').addClass('footer-animation-in');
    }, 2500);


    $('.tier-2-title').attr({
      "data-aos": "zoom-in",
      "data-aos-easing": "ease-in-out",
      "data-aos-duration": "180",
      "data-aos-delay": "200",
      "data-aos-once": "true",
      "data-aos-offset": "200"
    })

    $('#tier2Slideshow').attr({
      "data-aos": "zoom-in",
      "data-aos-easing": "ease-in-out",
      "data-aos-duration": "180",
      "data-aos-delay": "400",
      "data-aos-once": "true",
      "data-aos-offset": "300",
    })

    let checkClass = $('tier-4-container');
    if (checkClass.hasClass('centerContent')) {
      $('#seoBlock').attr({
        "data-aos": "fade-left",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "180",
        "data-aos-delay": "200",
        "data-aos-once": "true",
        "data-aos-offset": "150"
      })

      $('.cow-abstract').attr({
        "data-aos": "fade-up",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "800",
        "data-aos-delay": "300",
        "data-aos-once": "true",
        "data-aos-offset": "250"
      })
    } else {
      $('#seoBlock').attr({
        "data-aos": "fade-in",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "180",
        "data-aos-delay": "200",
        "data-aos-once": "true",
        "data-aos-offset": "100"
      })

      $('.cow-abstract').attr({
        "data-aos": "fade-up",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "800",
        "data-aos-delay": "500",
        "data-aos-once": "true",
        "data-aos-offset": "350"
      })
    }

    $('.map-overlay').attr({
      "data-aos": "flip-left",
      "data-aos-easing": "ease-in-out",
      "data-aos-duration": "180",
      "data-aos-delay": "200",
      "data-aos-once": "true",
      "data-aos-offset": "100"
    })



    $('.footer-logo').attr({
      "data-aos": "zoom-in",
      "data-aos-easing": "ease-in-out",
      "data-aos-duration": "180",
      "data-aos-delay": "400",
      "data-aos-once": "true",
      "data-aos-offset": "200"
    })
  });
});






$(window).load(function () {

  setTimeout(() => {
    let countContainer = $('#countdown-container .inner-content')
    $('#siteInfoBannerWidget').appendTo(countContainer);


  }, 800);
  // Weather Script
  //--------------------------------------
  setInterval(function () {
    let str = $('#weatherBugDescription').text();
    let weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return
    $('#weatherBugWidget').addClass('weatherBugSet');
    let findSpace = str.lastIndexOf(' ');
    let stringLength = str.length;
    let res = str.substring(findSpace, stringLength);
    let start = str.substring(0, findSpace);
    $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
    $('#weatherBugWidget').css('visibility', 'visible');
  }, 12);
});




